import { render, staticRenderFns } from "./ntmTable.vue?vue&type=template&id=c1c23816"
import script from "./ntmTable.vue?vue&type=script&lang=js"
export * from "./ntmTable.vue?vue&type=script&lang=js"
import style0 from "./ntmTable.vue?vue&type=style&index=0&id=c1c23816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports